import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreTileTagsComponent from './StoreTileTags.js';

const StoreTileTagsContainer = ({ tags  })=>{
    const { getLabel  } = useIntl();
    const labels = {
        hearingAppointmentPossible: getLabel('locations.component.storeTileIcons.hearingAppointmentPossibleShort'),
        wheelchairAccessible: getLabel('locations.component.storeTileIcons.wheelchairAccessible'),
        isFranchiseStore: getLabel('locations.component.storeTileIcons.franchiseStoreShort')
    };
    const enabledTags = Object.keys(tags).filter((name)=>tags[name]
    );
    if (!enabledTags) {
        return null;
    }
    const tagLabels = enabledTags.map((tag)=>labels[tag]
    );
    return /*#__PURE__*/ React.createElement(StoreTileTagsComponent, {
        tags: tagLabels
    });
};
var StoreTileTagsContainer$1 = StoreTileTagsContainer;

export { StoreTileTagsContainer$1 as default };
//# sourceMappingURL=StoreTileTagsContainer.js.map
